<template>
  <el-dialog
    top="1vh"
    width="1250px"
    custom-class="time-follow"
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="dialogVisible"
    @close="closeDialog">
    <section
      v-loading="searchLoading"
      element-loading-spinner="el-icon-loading"
      :element-loading-text="$t('timeTargetFollow.elementLoadingText')">
      <section class="one-row">
        <p class="row align-center text-p">
          <span class="row align-center space-center">1</span>
          <i>{{ $t('timeTargetFollow.tipsAnalysisFocusTime') }}</i>
        </p>
        <p class="row align-center text-p">
          <span class="row align-center space-center">2</span>
          <i>{{ $t('timeTargetFollow.tipsFocusYesterdayGap') }}</i>
        </p>
        <p class="row align-center text-p">
          <span class="row align-center space-center">3</span>
          <i>{{ $t('timeTargetFollow.tipsStrengthenTargetFocus') }}</i>
        </p>
        <div class="other">
          <div class="close" @click="closeDialog">
            <i class="el-icon-close"></i>
          </div>
          <div class="date-select row align-center">
            <span>{{ $t('timeTargetFollow.dateRowLabel') }}：</span>
            <el-date-picker
                v-model="date"
                style="width: 150px"
                size="small"
                type="date"
                :placeholder="$t('timeTargetFollow.datePickerPlaceholder')"
                value-format="yyyyMMdd"
                :clearable="false"
                :picker-options="pickerOptions"
                @change="fetch">
            </el-date-picker>
          </div>
          <div class="row align-center date-action">
            <span class="btn" @click="fetch()"><i class="el-icon-refresh"></i></span>
            <span class="btn" @click="saveHandel">{{ $t('timeTargetFollow.buttonSave') }}</span>
          </div>
        </div>
      </section>
      <div class="tip-row">
        <i class="el-icon-message-solid"></i>{{ $t('timeTargetFollow.tipRowDingTalkNotice') }}
      </div>
      <main class="main">
        <NoDataState
            v-if="!contentList.length"
            marginTop="220"
            :text-desc="$t('timeTargetFollow.noDataText')"
        ></NoDataState>
        <table v-else border>
          <tr v-for="(header, idx) in headerList" :key="idx">
            <td class="dept-name" rowspan="2" colspan="2" v-if="idx === 0">{{ deptCode }}</td>
            <td class="header-cell" v-for="(cell, c) in header.list" :key="c">
              {{ idx === 0 ? cell : cell.substring(5, 12) }}
            </td>
          </tr>
          <template v-for="(body, index) in contentList">
            <tr :key="body.time">
              <td rowspan="2" class="time-cell">{{ body.time }}</td>
              <td class="target-cell">{{ body.target }}</td>
              <td class="target" v-for="(target, t) in body.targetList" :key="t">
                {{ target.salesTotal }}
              </td>
            </tr>
            <tr :key="body.time + index">
              <td class="red">{{ body.sales }}</td>
              <td v-for="(sales, s) in body.salesList" :key="s" @click="changeTip(s)">
                <input
                    class="input red"
                    type="text"
                    v-model="sales.salesTotal"
                    @change="inputHandel(s, index + '', sales.salesTotal)"
                    @keyup.enter="$event.target.blur()"
                    :disabled="todayIndex !== s"
                />
              </td>
            </tr>
          </template>
          <tr v-for="(item, i) in totalList" :key="item.title">
            <td
                colspan="2"
                :class="[
                                i === 0 ? 'green' : i === 1 || i === 2 ? 'orange' : i === 3 ? 'gray' : 'lightBlue'
                            ]"
            >
              {{ item.title }}
            </td>
            <td
                :class="[
                                i === 0 ? 'green' : i === 1 || i === 2 ? 'orange' : i === 3 ? 'gray' : 'lightBlue'
                            ]"
                v-for="(cell, f) in item.list"
                :key="f"
            >
              <input
                  class="input footer-input red"
                  type="text"
                  v-if="i === 3"
                  v-model="cell.salesTotal"
                  @change="inputHandel(f, '4', cell.salesTotal)"
                  @keyup.enter="$event.target.blur()"
                  disabled
              />
              <span v-else :class="[i === 4 ? 'red' : '']">{{ cell.salesTotal }}</span>
            </td>
          </tr>
        </table>
      </main>
    </section>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import stockTopMenu from '@/components/stockTopMenu.vue'
import NoDataState from '@/components/noDataState'
import { queryPeriodFollow, updatePeriodFollow } from '@/libs/http/api'
export default {
  name: 'timeTargetFollow',
  components: {
    stockTopMenu,
    NoDataState
  },
  data() {
    return {
      dialogVisible: true,
      deptName: this.$cache.local.get('deptName'),
      deptCode: this.$cache.local.get('deptCode'),
      pickerOptions: {
        disabledDate(time) {
          // 获取当前日期
          const today = new Date();
          // 获取当前月份的第一天和最后一天
          const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
          const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          // 判断选择的日期是否不在当前月份内
          return time.getTime() < firstDayOfMonth.getTime() || time.getTime() > lastDayOfMonth.getTime();
        }
      },
      searchLoading: false,
      saveLoading: false,
      date: moment().format('yyyyMMDD'),
      today: moment().format('yyyy年MM月DD日'),
      todayIndex: '',
      headerList: [],
      contentList: [],
      totalList: [],
      saveList: []
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    closeDialog(){
      this.dialogVisible = false
      this.$emit('close')
    },
    fetch(e) {
      if (e) {
        this.date = e
      }
      this.searchLoading = true
      queryPeriodFollow({
        forDate: this.date,
        deptId: this.$cache.local.get('deptId')
      })
          .then((data) => {
            this.searchLoading = false
            this.headerList = data.headerList || []
            this.contentList = data.contentList || []
            this.totalList = data.totalList || []
            this.todayIndex = this.headerList[1].list.findIndex((item) => {
              return item === this.today
            })
          })
          .catch((error) => {
            this.searchLoading = false
            this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
          })
    },
    changeTip(s) {
      if (s !== this.todayIndex)
        return this.$message({
          type: 'error',
          message: this.$t('timeTargetFollow.messageCannotModifyExceptToday'),
          duration: 2000,
          showClose: true
        })
    },
    inputHandel(s, type, value) {
      const date = this.headerList[1].list[s]
      const forDate = date.substring(0, 4) + date.substring(5, 7) + date.substring(8, 10)
      let saveObj = {
        type: type,
        value: value,
        forDate: forDate
      }
      let idx = this.saveList.findIndex((item) => {
        return item.type === saveObj.type && item.forDate === saveObj.forDate && item.value !== saveObj.value
      })
      if (idx !== -1) {
        this.saveList.splice(idx, 1, saveObj)
      }
      let index = this.saveList.findIndex((item) => {
        return item.type === saveObj.type && item.forDate === saveObj.forDate && item.value === saveObj.value
      })
      if (index === -1) {
        this.saveList.push(saveObj)
      }
      this.saveHandel()
    },
    saveHandel() {
      if (!this.saveList.length)
        return this.$message({
          type: 'error',
          message: this.$t('timeTargetFollow.messageModifyBeforeSave'),
          duration: 2000,
          showClose: true
        })
      if (this.saveLoading) return
      this.saveLoading = true
      this.searchLoading = true
      updatePeriodFollow({
        list: this.saveList,
        deptId: this.$cache.local.get('deptId')
      })
          .then((data) => {
            this.saveList = []
            this.saveLoading = false
            this.fetch()
            this.$message({
              type: 'success',
              message: this.$t('timeTargetFollow.messageOperationSuccess'),
              duration: 2000,
              showClose: true
            })
          })
          .catch((error) => {
            this.saveLoading = false
            this.searchLoading = false
            this.$message({ type: 'error', message: error, duration: 2000, showClose: true })
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.one-row {
  padding: 0 10px;
  background: #fff;
  position: relative;
  .text-p {
    color: #000;
    font-size: 18px;
    padding-top: 10px;
    span {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      transform: rotate(6deg);
      background: rgb(230, 247, 255);
      font-weight: 900;
      margin-right: 10px;
      font-size: 20px;
    }
  }
  .other{
    position: absolute;
    top: 0;
    right: 10px;
    .close{
      color: #000;
      margin: 10px 0 10px 0;
      display: flex;
      font-size: 20px;
      cursor: pointer;
      justify-content: flex-end;
    }
    .date-action{
      margin-top: 10px;
      display: flex;
      justify-content: flex-end;
      .btn{
        background: #0b83f3;
        color: #fff;
        height: 31px;
        line-height: 31px;
        border-radius: 4px;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
        padding: 0 10px;
      }
    }

  }
}
.tip-row {
  color: #000;
  padding: 6px 0;
  font-size: 16px;
  margin-top: 10px;
  background: rgb(254, 249, 239);
  i {
    margin: 0 10px;
    color: rgb(248, 71, 95);
  }
}
.main {
  background: #fff;
  margin-top: 10px;
  table {
    border-collapse: collapse;
    border: 1px solid #bbb;
    font-weight: bold;
    td {
      width: calc(100% / 9);
      height: calc((100vh - 230px) / 15.2);
      text-align: center;
      color: #000;
    }
    .dept-name {
      background-color: #ffff00;
      font-size: 32px;
    }
    .header-cell {
      background-color: #ffff00;
    }
    .time-cell {
      background-color: #d8d8d8;
    }
    .target-cell {
      background-color: #e2f0d9;
    }
    .target {
      background-color: #e2f0d9;
    }
    .input {
      background: none;
      outline: none;
      border: none;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      width: 100%;
      height: 100%;
      &.footer-input {
        background-color: #ffff00;
      }
    }
    .green {
      background-color: #92d14f;
    }
    .orange {
      background-color: #f7caab;
    }
    .gray {
      background-color: #d8d8d8;
    }
    .lightBlue {
      background-color: #a1f4ec;
      &:not(:first-child) {
        background-color: #ffffff;
      }
    }
    .red {
      color: #f8475f;
    }
  }
}
</style>

<style>
.time-follow .el-dialog__header{
  padding: 0;
}
.time-follow .el-dialog__body{
  padding: 0;
}
</style>